import { BaseResource } from 'utils/ApiUtils';

export default class WorkItem extends BaseResource {
  constructor(args) {
    super(args, WorkItem.attributes)
  }

  static columns = [
    { title: "Id", field: "WorkItemId", type: "guid", hidden: true },
    { title: "Error", field: "Error", hidden: true },
    { title: "Item #", field: "WorkItemNumber", type:"string", defaultSort: "asc" },
    { title: "Code", field: "ItemCode", type:"string" },
    { title: "Description", field: "Description", type:"string", cellStyle: {width: 2}},
    { title: "Quantity", field: "Quantity", type: "numeric", cellStyle: {width: 2222}},
    { title: "Units", field: "Units" },
    { title: "Unit Price", field: "UnitPrice", type: "currency", align: 'left' },
    { title: "Project Id", field: "ProjectId", hidden: true },
    { title: "WorkItemsStatusId", field: "WorkItemsStatusId", type:"string", hidden: true  },
    { title: "Status", field: "Description_WorkItemsStatus", type:"string" },
    { title: "Type", field: "Description_Witype", type:"string" },
    { title: "Work Item Type Id", field: "WitypeId", type:"string", hidden: true },
    { title: "Delete", field: "Delete", hidden: true },
    { title: "Active?", field: "IsActive", type: "boolean" }
  ]

  static attributes = WorkItem.columns.map(r => r.field);
  
  static expand = [
    { 'Witype': { select: ['Description'] } },
    { 'WorkItemsStatus': { select: ['Description'] } }
  ]
}